import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'router-credentials',
  templateUrl: './router-credentials.component.html',
  styleUrls: ['./router-credentials.component.scss']
})
export class RouterCredentialsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
